import { Button } from '@iheartjane/reefer';

import type { ReviewableProduct } from '../../reviewableProduct';
import { MoreToReviewList } from '../moreToReviewList/moreToReviewList';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';

export interface ChooseProductToReviewProps {
  moreToReview: ReviewableProduct[];
  onDone: () => void;
  onReviewProduct: (product: ReviewableProduct) => void;
  testId?: string;
}

/**
 * Rate & Review phase reached by going back from a review, shared by every
 * A/B test variant. Lists the products to review without a confirmation.
 */
export function ChooseProductToReview({
  moreToReview,
  onDone,
  onReviewProduct,
  testId = 'choose-product-to-review',
}: ChooseProductToReviewProps) {
  return (
    <>
      <RateAndReviewModal.Body testId={testId}>
        <MoreToReviewList
          heading={`${moreToReview.length} to review`}
          headingLevel="h2"
          onReviewProduct={onReviewProduct}
          products={moreToReview}
          testId={testId}
        />
      </RateAndReviewModal.Body>
      <RateAndReviewModal.Footer>
        <Button label="I'm done" onClick={onDone} variant="tertiary" />
      </RateAndReviewModal.Footer>
    </>
  );
}
